/*LIBRARY*/
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

/*COMPONENT*/

/*REDUX*/
import { create_folder_project } from "../../App/actions/folderProjectAction";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const CREATE_FOLDER_PROJECT = ({ toggle_create_folder }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const project = useSelector((state) => state.project);

  //local state
  const [name, set_name] = useState("");

  const on_change = (e) => {
    set_name(e.target.value);
  };

  const on_submit = (e) => {
    e.preventDefault();
    const body = {
      name,
      folder_parent_id: project.folder_id_selected,
      project_id_list: [],
    };
    dispatch(create_folder_project(body));
    toggle_create_folder();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { folder_object_selected } = project;

  //content
  return (
    <main>
      <form onSubmit={on_submit}>
        {folder_object_selected?._id && (
          <section className="container_light background_grey_light margin_bottom">
            <p>
              {dict?.["In a folder"]?.[language]}: <br /> <br />
              <b className="text_medium">{folder_object_selected?.name}</b>
            </p>
          </section>
        )}
        <p className="margin_top margin_bottom text_bold">
          {dict?.["Enter a folder name"]?.[language]}
        </p>
        <input
          name="name"
          value={name}
          onChange={on_change}
          type="text"
          className="margin_bottom_extra"
          placeholder={dict?.["Folder name"]?.[language]}
          data-mapid="insertFolderName"
        />
        <button
          type="submit"
          className="button_big background_black"
          data-mapid="clickSubmit"
        >
          {dict?.["Save"]?.[language]}
        </button>
      </form>
    </main>
  );
};

CREATE_FOLDER_PROJECT.propTypes = {
  toggle_create_folder: PropTypes.func.isRequired,
};

export default CREATE_FOLDER_PROJECT;
